import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["recommendedButton", "followingButton", "indicator", "slider", "recommended", "following"]

  connect() {
    this.timers = new Set()
    if (document.documentElement.hasAttribute("data-turbo-preview")) return
    const saved = this.element.dataset.activeTab || localStorage.getItem("communityFeedTab")
    this.indicatorTarget.style.transition = "none"
    this.sliderTarget.style.transition = "none"
    this.activate(saved === "following" ? "following" : "recommended", false)
    this.indicatorTarget.offsetHeight
    this.indicatorTarget.style.transition = ""
    this.sliderTarget.style.transition = ""
  }

  disconnect() {
    this.timers.forEach(clearTimeout)
  }

  cache() {
    this.saveScroll()
    this.timers.forEach(clearTimeout)
    this.timers.clear()
  }

  select(event) {
    this.activate(event.currentTarget.dataset.option)
  }

  activate(option, save = true) {
    if (save) this.saveScroll()
    this.element.dataset.activeTab = option
    const recommended = option === "recommended"
    this.recommendedButtonTarget.classList.toggle("text-warm-gray-900", recommended)
    this.recommendedButtonTarget.classList.toggle("text-warm-gray-600", !recommended)
    this.followingButtonTarget.classList.toggle("text-warm-gray-900", !recommended)
    this.followingButtonTarget.classList.toggle("text-warm-gray-600", recommended)
    this.indicatorTarget.classList.toggle("translate-x-[calc(100%+0.25rem)]", !recommended)
    this.indicatorTarget.classList.toggle("translate-x-0", recommended)
    this.sliderTarget.classList.toggle("-translate-x-full", !recommended)
    this.sliderTarget.classList.toggle("translate-x-0", recommended)
    const frame = this.activeFrame
    if (!frame.getAttribute("src") && !frame.hasAttribute("complete")) {
      frame.setAttribute("src", this.element.dataset[`${option}Path`])
    }
    localStorage.setItem("communityFeedTab", option)
    this.element.dispatchEvent(new CustomEvent("community:tab-change", { bubbles: true }))
    this.later(() => this.restoreScroll(option), 50)
  }

  saveScroll() {
    const tab = this.element.dataset.activeTab || "recommended"
    this.element.dataset[`scrollY_${tab}`] = window.scrollY
  }

  restoreScroll(tab = this.element.dataset.activeTab) {
    window.scrollTo(0, parseInt(this.element.dataset[`scrollY_${tab}`] || "0", 10))
  }

  refresh() {
    this.element.dataset.scrollY_recommended = "0"
    window.scrollTo(0, 0)
  }

  frameLoaded(event) {
    if (event.target === this.activeFrame) this.later(() => this.restoreScroll(), 100)
  }

  get activeFrame() {
    return this.element.dataset.activeTab === "recommended" ? this.recommendedTarget : this.followingTarget
  }

  later(callback, delay) {
    const timer = setTimeout(() => {
      this.timers.delete(timer)
      callback()
    }, delay)
    this.timers.add(timer)
  }
}
